var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-badge success",class:{'payment-text':(!_vm.isXS(null)),'payment-text-small':(_vm.isXS(null))}},[_vm._v(_vm._s(_vm.priceDisplay(_vm.amount))+" "+_vm._s(_vm.userIsAdmin ? 'Pro ' : '')+"Payment")])}
var staticRenderFns = []

export { render, staticRenderFns }